import categoriesTree from '@anm/data/video-templates/categories-tree';

export const getPageFromSearch = (searchText: string) =>
  categoriesTree.reduce((acc, item) => {
    if (item.name === searchText) {
      return item.page;
    }
    if (item.children && !acc) {
      return item.children.reduce((acc, child) => {
        if (child.name === searchText) {
          return child.page;
        }

        return acc;
      }, '');
    }

    return acc;
  }, '');
